"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const string_escape_newlines_1 = require("@App/helpers/string-escape-newlines");
const contexts_1 = require("@App/contexts");
class AlternativeTitleCard extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "lang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const langCode = this.props.data.languageCode;
                const typeCode = this.props.data.titleType;
                const languagesOptions = this.context.libStore.languages;
                const titleTypeOptions = this.context.libStore.akaTitleTypes;
                if (!languagesOptions || !titleTypeOptions) {
                    return;
                }
                if (langCode) {
                    const findLanguage = languagesOptions.filter((option) => {
                        if (+option.id !== langCode) {
                            return;
                        }
                        return option;
                    });
                    this.lang = findLanguage.length > 0 && 'label' in findLanguage[0] ? findLanguage[0].label : '';
                }
                else {
                    this.lang = '';
                }
                if (typeCode) {
                    const findType = titleTypeOptions.filter((option) => {
                        if (+option.id !== typeCode) {
                            return;
                        }
                        return option;
                    });
                    this.type = findType.length > 0 && 'label' in findType[0] ? findType[0].label : '';
                }
                else {
                    this.type = '';
                }
            }
        });
        (0, mobx_1.makeObservable)(this, {
            lang: mobx_1.observable,
            type: mobx_1.observable,
            getOptions: mobx_1.action,
        });
    }
    componentDidMount() {
        this.getOptions();
    }
    render() {
        const { data, editFunc, removeFunc } = this.props;
        const akaTitle = data.title;
        const akaTitleType = data.titleType;
        const lang = data.languageCode;
        const akaTypeOptions = this.context.libStore.akaTitleTypes;
        const langOptions = this.context.libStore.languages;
        const classNames = ['alternative-title-card'].join(' ');
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: 'head' },
                react_1.default.createElement("p", { className: `bold ${(0, fields_validators_1.akaTitleInvalidCheck)(akaTitle) ? 'red-text' : ''}` }, akaTitle ? (0, string_escape_newlines_1.stringEscapeNewlines)(akaTitle) : ''),
                react_1.default.createElement("div", { className: 'controls' },
                    editFunc ? (react_1.default.createElement("span", { className: 'medium', onClick: editFunc }, "Edit")) : null,
                    removeFunc ? (react_1.default.createElement("span", { className: 'medium', onClick: () => removeFunc(data) }, "Remove")) : null)),
            react_1.default.createElement("div", { className: 'content' },
                react_1.default.createElement("p", { className: 'small' },
                    react_1.default.createElement("span", { className: `${(0, fields_validators_1.akaTitleTypeInvalidCheck)(akaTitleType, akaTypeOptions) ? 'red-text bold' : ''}` },
                        "Alternative title type:",
                        ' '),
                    react_1.default.createElement("strong", null, this.type)),
                react_1.default.createElement("p", { className: 'small' },
                    react_1.default.createElement("span", { className: `${(0, fields_validators_1.languageInvalidCheck)(lang, langOptions, false) ? 'red-text bold' : ''}` },
                        "Language:",
                        ' '),
                    react_1.default.createElement("strong", null, this.lang)))));
    }
}
exports.default = (0, mobx_react_1.observer)(AlternativeTitleCard);
AlternativeTitleCard.contextType = contexts_1.StoresContext;
